import React from "react"

const floodedBackground = ({ id, color }) => (
  <filter x="0" y="0" width="1" height="1" id={id}>
    <feFlood floodColor={color} />
    <feComposite in="SourceGraphic" operator="or" />
  </filter>
)

const innerGlow = ({
  id,
  color,
  radius = -10,
  blurriness = 10,
  opacity = 0.75
}) => (
  <filter id={id} height="300%" width="300%" x="-75%" y="-75%">
    <feGaussianBlur
      in="SourceAlpha"
      stdDeviation="3"
      result="blur"
     />
    <feOffset dy="2" dx="3" />
    <feComposite
      in2="SourceAlpha"
      operator="arithmetic"
      k2="-1"
      k3="1"
      result="shadowDiff"
     />

    <feFlood floodColor={color} floodOpacity={opacity} />
    <feComposite in2="shadowDiff" operator="in" />
    <feComposite
      in2="SourceGraphic"
      operator="over"
      result="firstfilter"
     />

    <feGaussianBlur
      in="firstfilter"
      stdDeviation="3"
      result="blur2"
     />
    <feOffset dy="-2" dx="-3" />
    <feComposite
      in2="firstfilter"
      operator="arithmetic"
      k2="-1"
      k3="1"
      result="shadowDiff"
     />

    <feFlood floodColor={color} floodOpacity={opacity} />
    <feComposite in2="shadowDiff" operator="in" />
    <feComposite in2="firstfilter" operator="over" />
  </filter>
)

const outerGlow = ({
  id,
  color,
  radius = 10,
  blurriness = 10,
  opacity = 0.5
}) => (
  <filter id={id} height="300%" width="300%" x="-75%" y="-75%">
    {/* <!-- Thicken out the original shape --> */}
    <feMorphology
      operator="dilate"
      radius={radius}
      in="SourceAlpha"
      result="thicken"
    />

    {/* <!-- Use a gaussian blur to create the soft blurriness of the glow --> */}
    <feGaussianBlur in="thicken" stdDeviation={blurriness} result="blurred" />

    {/* <!-- Change the colour --> */}
    <feFlood floodColor={color} floodOpacity={opacity} result="glowColor" />

    {/* <!-- Color in the glows --> */}
    <feComposite
      in="glowColor"
      in2="blurred"
      operator="in"
      result="softGlow_colored"
    />

    {/* <!--	Layer the effects together --> */}
    <feMerge>
      <feMergeNode in="softGlow_colored" />
      <feMergeNode in="SourceGraphic" />
    </feMerge>
  </filter>
)

export const filters = {
  floodedBackground,
  innerGlow,
  outerGlow
}
